import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    allScheduleList: () => {
        return HTTP.get('/leave/listLeave', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },    
    employeeList: () => {
        return HTTP.get('/leave/listEmployee', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    createLeaveSelectEmployee: (data) => {
        return HTTP.post('/leave/leaveCreateSelectEmployee',data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    editLeaveSelectEmployee: (id,data) => {
        return HTTP.post('/leave/leaveUpdateSelectEmployee/'+id,data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    employeeDetail: (id) => {
        return HTTP.get('/leave/leaveEditSelectEmployee/'+id, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}